export default __webpack_public_path__ + "store/static/media/dynamed-logo-white.ec1aea8d.svg";